module.exports = __webpack_public_path__ + "static/media/iconExclamationMarkRed.13e551f3.svg";